/**
 * Detect if a barcode is scanned while the window is focused
 * mainly for iOS devices for which we removed the input focus
 * @link http://www.deadosaurus.com/detect-a-usb-barcode-scanner-with-javascript/
 */
$(() => {
  let pressed = false;

  let keypressTimeout: TSFixMe = null;

  let chars: TSFixMe = [];

  $(window).on('keydown', e => {
    if (document.activeElement !== document.body) {
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      if (document.activeElement.tagName === 'INPUT') {
        onScan(e);
      }
      return;
    }
    const barcodeInput = $('.itembarcode:visible, .giftcardbarcode:visible').first();
    if (!barcodeInput.length) {
      return;
    }
    if (e.which >= 48 && e.which <= 57) {
      chars.push(String.fromCharCode(e.which));
    }
    if (!pressed) {
      keypressTimeout = window.setTimeout(() => {
        if (chars.length >= 10) {
          const searchButton = barcodeInput
            .trigger('focus')
            .val(chars.join(''))
            .delay(250)
            .closest('form')
            .find('button:contains(Search)');
          if (searchButton.length) {
            searchButton.trigger('click');
          } else {
            const otherSubmitButton = barcodeInput.closest('form').find('.barcodesubmit');
            if (otherSubmitButton.length) {
              otherSubmitButton.trigger('click');
            }
          }
        }
        chars = [];
        pressed = false;
        window.clearTimeout(keypressTimeout);
        keypressTimeout = null;
      }, 500);
    }
    pressed = true;
  });

  function onScan(event: TSFixMe) {
    if (event.key >= 0 && event.key <= 9) {
      chars.push(event.key);
    }
    if (
      chars.length >= 7 &&
      event.key === 'Enter' &&
      // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
      $(document.activeElement).hasClass('scanner-no-submit')
    ) {
      event.preventDefault();
    }
    if (pressed === false) {
      keypressTimeout = window.setTimeout(() => {
        chars = [];
        pressed = false;
        window.clearTimeout(keypressTimeout);
      }, 500);
    }
    pressed = true;
  }
});
